export default "<div>\r\n  <app-contact></app-contact>\r\n</div>\r\n"